<template>
  <div>
    <div style="margin-top: 20px;margin-bottom: 20px;">
      <Button status="primary" icon="ios-add" @click="addLink">绑定结算账户</Button>
      <Button icon="md-refresh" @click="refresh" style="margin-left: 10px">刷新</Button>
    </div>
    <vxe-table
        class="table-style"
        highlight-hover-row
        show-footer
        stripe
        align="center"
        border="none"
        auto-resize
        :data="tableData"
        max-height="540"
        :loading="loading"
    >
      <vxe-table-column field="id" title="序号" width="100">
        <template slot-scope="{ row }">
          <span>{{ row.id }}</span>
        </template>
      </vxe-table-column>
      <vxe-table-column title="操作">
        <template slot-scope="{ row }">
          <span style="color: #2d8cf0; cursor: pointer; margin-right: 10px" @click="removeLink(row)">解绑</span>
        </template>
      </vxe-table-column>
      <vxe-table-column field="bindAccName" title="结算账户"></vxe-table-column>
      <vxe-table-column field="bindOpenBankName" title="结算开户银行"></vxe-table-column>
      <vxe-table-column field="bindOpenOrgNum" title="联行号"></vxe-table-column>
      <vxe-table-column field="bindAccNum" title="结算银行账号"></vxe-table-column>
    </vxe-table>
    <vxe-modal v-model="linkAccountModal" width="500" height="350" position="center" title="绑定结算账户">
      <link-account ref="linkAccount"  @afterSave="afterSave"  @close="close"></link-account>
    </vxe-modal>
  </div>
</template>
<script>
  import LinkAccount from "./LinkAccount";
  import $api from "@/apiProvider";
  import {showLoading, hideLoading} from "@/utils/util";

  export default {
    components: {LinkAccount},
    data() {
      return {
        memInfo: {},
        loading: false,
        tableData: [],
        linkAccountModal: false,
        obj: {}
      }
    },
    methods: {
      init(memInfo) {
        this.memInfo = memInfo;
        this.obj = {memNum: memInfo.memNum};
        this.listBindAcc();
      },
      async listBindAcc() {
        this.loading = true;
        let res = await $api.finance.request("bindAcc/listBindAcc", this.obj);
        this.loading = false
        if (res.status === 1) {
          this.tableData = res.data;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      removeLink(row) {
        this.$XModal.confirm("您确定要解绑吗？").then((type) => {
          if (type === "confirm") {
            this.bindAcc(row.bindAccNum);
          }
        });
      },
      async bindAcc(bindAccNum) {
        showLoading();
        let obj = {
          bindAccNum: bindAccNum,
          opeAccType: 2,
          subAcc: this.memInfo.subAcc
        }
        let res = await $api.finance.request("bindAcc/bindAcc", obj);
        hideLoading();
        if (res.status === 1) {
          this.$Message.success("解绑成功");
          this.listBindAcc();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      afterSave() {
        this.listBindAcc();
        this.linkAccountModal = false;
      },
      addLink() {
        this.linkAccountModal = true;
        this.$refs.linkAccount.init(this.memInfo)
      },
      close() {
        this.linkAccountModal = false;
      },
      refresh() {
        this.listBindAcc();
      }
    }
  }
</script>
<style>

</style>